<template>
    <div class="project-detail-statistic-board-scrollview">
        <div class="project-detail-statistic-board">
            <div>
                <div class="ah-card main-color">
                    <div class="content col">
                        <div class="block-title" style="display: flex; justify-content: space-between">
                            <div>專案總額（共{{ totalProjectCount }}筆）</div>
                            <div>
                                <el-radio-group v-model="summaryTab" size="small">
                                    <el-radio-button label="status" class="table-option">狀態</el-radio-button>
                                    <el-radio-button label="invoice" class="table-option">開發票</el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <div class="value-statistic">
                            <div class="money-block">
                                <Money :v="projectTotalAmt" round />
                                <span class="cny">TWD</span>
                            </div>
                        </div>
                        <div></div>
                        <div class="two-cols">
                            <div class="left">
                                <v-chart ref="pieChart" :option="pieChartOption" />
                            </div>
                            <div class="right">
                                <div class="compare-block" style="margin-top: 10px">
                                    <template v-if="summaryTab === 'status'">
                                        <div v-for="(item, index) in pjStatisticStatusData" :key="index">
                                            <div class="title">
                                                <span class="ball" :style="{ 'background-color': item.ballColor }"></span>
                                                <span>{{ item.label }} ({{ getData(item.countField) || '--' }})</span>
                                            </div>
                                            <div class="value">
                                                <Money :v="getData(item.numField)" round />
                                            </div>
                                            <!-- <div class="value">{{ getPercentage(data[item.numField], projectTotalAmt) }} %</div> -->
                                        </div>
                                    </template>
                                    <template v-if="summaryTab === 'invoice'">
                                        <div v-for="(item, index) in pjStatisticInvoiceData" :key="index">
                                            <div class="title">
                                                <span class="ball" :style="{ 'background-color': item.ballColor }"></span>
                                                <span
                                                    >{{ item.label }} <ah-tip v-if="item.tip">{{ item.tip }}</ah-tip></span
                                                >
                                            </div>
                                            <div class="value">
                                                <Money :v="getData(item.numField, true)" round />
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="ah-card main-color">
                    <div class="content col">
                        <div class="block-title">開立發票總額（含稅）<ah-tip>已開發票總額 - (作廢 + 折讓)</ah-tip></div>
                        <div class="value-statistic">
                            <div class="money-block">
                                <Money :v="validIssuedInvoiceTotal" round />
                                <span class="cny">TWD</span>
                            </div>
                            <div class="percentage-text">{{ validIssuedInvoicePercentageNum }}%</div>
                        </div>
                        <div class="percentage">
                            <el-progress :stroke-width="6" :percentage="issuedInvoicePercentage" :show-text="false" color="#56c500" define-back-color="rgba(0,0,0,0.25)" />
                        </div>
                        <div class="compare-block">
                            <div v-for="(item, index) in invoiceStaticData" :key="index" :class="{ seperator: item.type === 'seperator' }">
                                <template v-if="item.type === 'seperator'">
                                    <div class="title"></div>
                                    <div class="value"></div>
                                </template>
                                <template v-else>
                                    <div class="title">{{ item.label }}</div>
                                    <div class="value">
                                        <Money :v="getData(item.dataField, item.isComputed)" round />
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="ah-card main-color">
                    <div class="content col">
                        <div class="block-title">實際已支出</div>
                        <div class="value-statistic">
                            <div class="money-block">
                                <Money :v="totalPayout" round />
                                <span class="cny">TWD</span>
                            </div>
                            <div class="percentage-text">{{ budgetPercentageNum }}%</div>
                        </div>
                        <div class="percentage">
                            <el-progress :stroke-width="6" :percentage="budgetPercentage" :show-text="false" color="#56c500" define-back-color="rgba(0,0,0,0.25)" />
                        </div>
                        <div class="compare-block">
                            <div v-for="(item, index) in payoutStaticData" :key="index">
                                <div class="title">{{ item.label }}</div>
                                <div class="value">
                                    <Money :v="getData(item.dataField, item.isComputed)" round />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="ah-card main-color">
                    <div class="content col">
                        <div class="block-title">毛利 <ahTip>以篩選條件結果計算</ahTip></div>
                        <div class="value-statistic">
                            <div class="money-block">
                                <Money :v="actualProfit" round />
                                <span class="cny">TWD</span>
                            </div>
                            <div class="percentage-text">{{ totalProfitPercentageNum }}%</div>
                        </div>
                        <div class="percentage">
                            <el-progress :stroke-width="6" :percentage="totalProfitPercentage" :show-text="false" color="#56c500" define-back-color="rgba(0,0,0,0.25)" />
                        </div>
                        <div class="compare-block">
                            <div v-for="(item, index) in profitStaticData" :key="index">
                                <div class="title">{{ item.label }}</div>
                                <div class="value">
                                    <Money :v="getData(item.dataField, item.isComputed)" round />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';

import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    components: { VChart },
    props: {
        isLoading: Boolean,
        data: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            summaryTab: 'status', // 專案總額分頁：status, invoice
            pjStatisticStatusData: [
                {
                    label: '進行中',
                    ballColor: '#FFE36C',
                    numField: 'ongoingProjectTotalAmount',
                    countField: 'ongoingProjectCount',
                },
                {
                    label: '結案',
                    ballColor: '#56C500',
                    numField: 'completedProjectTotalAmount',
                    countField: 'completedProjectCount',
                },
            ],
            pjStatisticInvoiceData: [
                {
                    label: '開立發票總額',
                    ballColor: '#FFE36C',
                    numField: 'validIssuedInvoiceTotal',
                    tip: '已開發票總額 - (作廢總額 + 折讓總額)',
                },
                {
                    label: '未開發票總額',
                    ballColor: '#56C500',
                    numField: 'nonIssuedInvoiceTotal',
                },
            ],
            payoutStaticData: [
                {
                    label: '剩餘預算',
                    dataField: 'remainBudget',
                    isComputed: true,
                },
                {
                    label: '總預算',
                    dataField: 'totalBudget',
                    isComputed: true,
                },
            ],
            profitStaticData: [
                {
                    label: '實際已支出',
                    dataField: 'totalPayout',
                    isComputed: true,
                },
                {
                    label: '專案總額',
                    dataField: 'projectTotalAmt',
                    isComputed: true,
                },
            ],
            invoiceStaticData: [
                // {
                //     label: '專案總額',
                //     dataField: 'projectTotalAmt',
                //     isComputed: true,
                // },
                // {
                //     type: 'seperator',
                // },
                {
                    label: '已開發票總額',
                    dataField: 'issuedInvoiceTotal',
                    isComputed: true,
                },
                {
                    label: '− 作廢',
                    dataField: 'voidedInvoiceTotal',
                    isComputed: true,
                },
                {
                    label: '− 折讓',
                    dataField: 'discountedInvoiceTotal',
                    isComputed: true,
                },
            ],
        };
    },
    computed: {
        pieChartOption() {
            const option = {
                color: ['#56C500', '#FFE36C'],
                series: [
                    {
                        type: 'pie',
                        radius: ['48%', '83%'],
                        center: ['45%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                        },
                        data: [
                            { name: '', value: 0 },
                            { name: '', value: 0 },
                        ],
                    },
                ],
            };

            if (this.summaryTab === 'status') {
                option.series[0].data[0].name = '結案';
                option.series[0].data[0].value = Math.round(this.data.completedProjectTotalAmount);
                option.series[0].data[1].name = '進行中';
                option.series[0].data[1].value = Math.round(this.data.ongoingProjectTotalAmount);
            } else if (this.summaryTab === 'invoice') {
                option.series[0].data[0].name = '未開發票總額';
                option.series[0].data[0].value = Math.round(this.nonIssuedInvoiceTotal);
                option.series[0].data[1].name = '開立發票總額';
                option.series[0].data[1].value = Math.round(this.validIssuedInvoiceTotal);
            }

            return option;
        },

        projectTotalAmt() {
            return this.data.ongoingProjectTotalAmount + this.data.completedProjectTotalAmount;
        },
        totalPayout() {
            return this.data.completedActualTotalExpenditure + this.data.ongoingActualTotalExpenditure;
        },
        totalBudget() {
            return this.data.completedExpenseBudget + this.data.ongoingExpenseBudget;
        },
        remainBudget() {
            return this.totalBudget - this.totalPayout;
        },
        budgetPercentageNum() {
            if (!this.totalBudget) return '--';
            return Math.round((this.totalPayout / this.totalBudget) * 1000) / 10;
        },
        budgetPercentage() {
            if (!this.totalBudget) return 0;
            if (this.budgetPercentageNum > 100) return 100;
            return this.budgetPercentageNum;
        },

        actualProfit() {
            return this.projectTotalAmt - this.totalPayout;
        },
        totalProfitPercentageNum() {
            if (!this.projectTotalAmt) return '--';
            return Math.round((this.actualProfit / this.projectTotalAmt) * 1000) / 10;
        },
        totalProfitPercentage() {
            if (!this.projectTotalAmt) return 0;
            if (this.totalProfitPercentageNum > 100) return 100;
            return this.totalProfitPercentageNum;
        },

        issuedInvoiceTotal() {
            return this.data.completedIssuedInvoiceTotal + this.data.ongoingIssuedInvoiceTotal;
        },
        validIssuedInvoiceTotal() {
            return this.issuedInvoiceTotal - this.voidedInvoiceTotal - this.discountedInvoiceTotal;
        },
        nonIssuedInvoiceTotal() {
            return this.data.completedNonIssuedInvoiceTotal + this.data.ongoingNonIssuedInvoiceTotal;
        },
        voidedInvoiceTotal() {
            return this.data.completedVoidedInvoiceTotal + this.data.ongoingVoidedInvoiceTotal;
        },
        discountedInvoiceTotal() {
            return this.data.completedDiscountedInvoiceTotal + this.data.ongoingDiscountedInvoiceTotal;
        },
        validIssuedInvoicePercentageNum() {
            if (!this.projectTotalAmt) return '--';
            return Math.round((this.validIssuedInvoiceTotal / this.projectTotalAmt) * 1000) / 10;
        },
        issuedInvoicePercentage() {
            if (!this.projectTotalAmt) return 0;
            if (this.validIssuedInvoicePercentageNum > 100) return 100;
            return this.validIssuedInvoicePercentageNum;
        },

        totalProjectCount() {
            const COUNT = this.data.ongoingProjectCount + this.data.completedProjectCount;
            return COUNT || '--';
        },
    },
    methods: {
        getData(field, isComputed) {
            if (isComputed) return this[field];
            return this.data[field];
        },
        getPercentage(molecular, denominator) {
            if (!denominator) return '--';
            return Math.round((molecular / denominator) * 1000) / 10;
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.project-detail-statistic-board-scrollview {
    overflow-x: auto;

    &::-webkit-scrollbar {
        width: 0px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: #ffffffcc;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #ffffffee;
    }
}
.project-detail-statistic-board {
    display: grid;
    grid-template-columns: 3fr 2fr 2fr 2fr;
    justify-content: space-between;
    padding: 0;
    gap: 15px;

    // @media (max-width: 1200px) {
    //     grid-template-columns: 2fr 2fr;
    // }

    @media (max-width: 1200px) {
        grid-template-columns: 3fr 2fr 2fr 2fr;
        min-width: 1200px;
    }

    .ah-card {
        height: 210px;
        width: 100%;

        .block-title {
            font-size: 11pt;
            font-weight: bold;
            margin-bottom: 5px;
        }
    }
    .content {
        height: 100%;
        display: flex;
        &.col {
            flex-direction: column;
        }
    }

    .two-cols {
        display: flex;
        align-items: start;
        height: 100%;

        > .left {
            flex-shrink: 0;
            width: 130px;
            height: 100px;
            margin-right: 10px;
        }
        > .right {
            width: 100%;
        }
    }
    .value-statistic {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        .percentage-text {
            color: #fff;
            font-weight: normal;
            font-size: 10pt;
            opacity: 0.5;
        }
    }
    .percentage {
        padding-top: 5px;
        .el-progress {
            .el-progress-bar {
                .el-progress-bar__outer {
                    background-color: rgba(0, 0, 0, 0.2);
                }
            }
        }
    }
    .compare-block {
        font-size: 9.5pt;
        display: table;
        width: 100%;
        margin: 20px 0 0;

        &.no-margin {
            margin: 0;
        }

        > * {
            display: table-row;
            width: 50%;

            &.seperator {
                > * {
                    padding: 4px 0;
                    &::after {
                        display: block;
                        content: "";
                        width: 100%;
                        height: 1px;
                        background-color: #ffffff44;
                    }
                }
            }

            > .title {
                display: table-cell;
            }
            > .value {
                display: table-cell;
                text-align: right;
            }
        }

        .ball {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            margin-right: 5px;
        }
    }
    .money-block {
        .money {
            font-size: 13pt;
            font-weight: normal;
        }
        .cny {
            color: rgba(255, 255, 255, 0.4);
            font-size: 8pt;
            margin-left: 5px;
        }
    }
}
</style>
